'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILTER_TYPES = {
	regions: { value: 'regions', label: 'Territory' },
	store_types: { value: 'store_types', label: 'Type' },
	store_markets: { value: 'store_markets', label: 'Market' },
	store_status: { value: 'store_status', label: 'Status' },
	store_city: { value: 'store_city', label: 'City' },
	store_state: { value: 'store_state', label: 'State' },
	store_country: { value: 'store_country', label: 'Country' },
	store_rating: { value: 'store_rating', label: 'Rating' },
	stores: { value: 'stores', label: 'Stores' },
	brands: { value: 'brands', label: 'Brands' },
	seasons: { value: 'seasons', label: 'Seasons' },
	budget_seasons: { value: 'budget_seasons', label: 'Seasons' },
	payment_terms: { value: 'payment_terms', label: 'Payment Terms' },
	brand_category: { value: 'brand_category', label: 'Category' },
	brand_type: { value: 'brand_type', label: 'Type' },
	brand_status: { value: 'brand_status', label: 'Status' },
	departments: { value: 'departments', label: 'Department' },
	territory: { value: 'territory', label: 'Territory' },
	contact_types: { value: 'contact_types', label: 'Type' },
	contact_titles: { value: 'contact_titles', label: 'Title' },
	order_status: { value: 'order_status', label: 'Order Status' },
	is_sor: { value: 'is_sor', label: 'SOR' },
	is_consignment: { value: 'is_consignment', label: 'Consignment' },
	has_discount: { value: 'has_discount', label: 'Has Discount' },
	tradeshow: { value: 'tradeshow', label: 'Tradeshow' },
	order_collection: { value: 'order_collection', label: 'Collection' }
};

var Filters = function (_React$Component) {
	_inherits(Filters, _React$Component);

	function Filters(props) {
		_classCallCheck(this, Filters);

		var _this = _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));

		_this.myRefs = [];
		_this.state = {
			filters: _this.transformFiltersToArray(_this.queryObject.bind(_this)()),
			changed: false,
			filterOptions: {}
		};

		_this.filterTypes = FILTER_LIST.map(function (item) {
			return FILTER_TYPES[item];
		});

		_this.selectOptions = {};
		_this.loadOptions.bind(_this)();
		// this.loadOptionsForFilter = this.loadOptionsForFilter.bind(this);
		_this.handleSubmit = _this.handleSubmit.bind(_this);
		return _this;
	}

	_createClass(Filters, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				'div',
				{ className: 'filters' },
				_react2.default.createElement(
					'div',
					{ className: 'filter-list' },
					this.state.filters.map(function (filter, i) {

						return _react2.default.createElement(
							'div',
							{ className: 'filter row', key: i },
							_react2.default.createElement(
								'div',
								{
									onClick: _this2.handleRemoveFilter.bind(_this2, i),
									className: 'remove col-md-1'
								},
								_react2.default.createElement('i', { className: 'ri-minus-o-invert' })
							),
							_react2.default.createElement(
								'div',
								{ className: 'type col-md-3' },
								_react2.default.createElement(_reactSelect2.default, {
									ref: function ref(e) {
										_this2.myRefs['type' + i] = e;
									},
									options: _this2.filterTypes,
									multi: false,
									clearable: false,
									value: filter.type,
									onChange: _this2.handleSetType.bind(_this2, i)
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'type col-md-3' },
								filter.type && _react2.default.createElement(_reactSelect2.default, {
									key: 'options_' + filter.type,
									multi: true,
									clearable: true,
									value: filter.values,
									onChange: _this2.handleSetValue.bind(_this2, i),
									options: _this2.state.filterOptions[filter.type],
									isLoading: !_this2.state.filterOptions[filter.type]
								})
							)
						);
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'add-filter row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-md-1', onClick: this.handleAddFilter.bind(this) },
						_react2.default.createElement('i', { className: 'ri-plus-o-invert' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-md-3', onClick: this.handleAddFilter.bind(this) },
						'Add Filter'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'save' },
					_react2.default.createElement(
						'a',
						{ className: (0, _classnames2.default)("rwi-btn-rounded pull-right clear-filters"), href: document.location.pathname },
						_react2.default.createElement('i', { className: 'ri-cross-o' }),
						'Clear Filters'
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)("rwi-btn-rounded", { 'rwi-btn-success': this.state.changed }), onClick: this.handleSubmit },
						'Update View'
					)
				)
			);
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions() {
			var _this3 = this;

			this.filterTypes.forEach(function (item) {
				var url = location.origin + '/ajax/' + item.value;
				(0, _request2.default)(url, function (err, resp, body) {
					var options = JSON.parse(body) || [];
					options = options.map(function (item) {
						return { value: item.label, label: item.label };
					});
					this.selectOptions[item.value] = options;
					this.setState(_extends({}, this.state, {
						filterOptions: _extends({}, this.state.filterOptions, _defineProperty({}, item.value, options))
					}));
				}.bind(_this3));
			});
		}
	}, {
		key: 'loadOptionsForFilter',
		value: function loadOptionsForFilter(slug) {

			if (!slug) return;

			var url = location.origin + '/ajax/' + slug;
			var context = this.state.filters.reduce(function (prev, curr) {
				prev[curr.type] = curr.values;
				return prev;
			}, {});
			var qs = {
				context: JSON.stringify(context)
			};

			(0, _request2.default)({ url: url, qs: qs }, function (err, resp, body) {
				var options = JSON.parse(body) || [];
				options = options.map(function (item) {
					return { value: item.label, label: item.label };
				});

				this.setState(_extends({}, this.state, {
					filterOptions: _extends({}, this.state.filterOptions, _defineProperty({}, slug, options))
				}));
			}.bind(this));
		}
	}, {
		key: 'handleSetType',
		value: function handleSetType(i, newValue) {
			var filters = [].concat(_toConsumableArray(this.state.filters));
			filters[i] = {
				type: newValue.value,
				values: []
			};

			this.loadOptionsForFilter(newValue.value);

			this.setState({
				filters: filters,
				changed: true
			});
		}
	}, {
		key: 'handleSetValue',
		value: function handleSetValue(i, newValue) {

			var filters = [].concat(_toConsumableArray(this.state.filters));
			filters[i] = _extends({}, filters[i], {
				values: newValue
			});

			this.setState({
				filters: filters,
				changed: true
			});
		}
	}, {
		key: 'handleAddFilter',
		value: function handleAddFilter() {
			var filters = [].concat(_toConsumableArray(this.state.filters), [{
				type: '',
				values: []
			}]);

			this.setState({
				filters: filters,
				changed: true
			}, function () {
				this.myRefs['type' + (filters.length - 1)].focus();
			}.bind(this));
		}
	}, {
		key: 'handleRemoveFilter',
		value: function handleRemoveFilter(i) {
			var filters = [].concat(_toConsumableArray(this.state.filters.slice(0, i)), _toConsumableArray(this.state.filters.slice(i + 1)));

			this.setState({
				filters: filters,
				changed: true
			});
		}
	}, {
		key: 'handleLoadData',
		value: function handleLoadData(i, term, callback) {
			var type = this.state.filters[i].type;
			var url = location.origin + '/ajax/' + type;
			(0, _request2.default)(url, function (err, resp, body) {
				var options = JSON.parse(body);
				callback(null, { options: options, complete: true });
			});
		}
	}, {
		key: 'handleSubmit',
		value: function handleSubmit() {
			var filters = this.transformFiltersToObj(this.state.filters);
			var queryParams = this.serialize.bind(this)(filters);

			location.href = location.pathname + '?' + queryParams;
		}
	}, {
		key: 'transformFiltersToObj',
		value: function transformFiltersToObj(filters) {
			var myObj = {};
			for (var i = 0; i < filters.length; i++) {
				if (!filters[i].type) continue;
				myObj[filters[i].type] = filters[i].values.map(function (i) {
					return typeof i == 'string' ? i : i.label;
				});
			}
			return myObj;
		}
	}, {
		key: 'serialize',
		value: function serialize(obj, prefix) {
			var this$1 = this;

			var str = [],
			    p;
			for (p in obj) {
				if (obj.hasOwnProperty(p)) {
					var k = prefix ? prefix + "[]" : p,
					    v = obj[p];
					str.push(v !== null && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === "object" ? this$1.serialize(v, k) : k + "=" + encodeURIComponent(v));
				}
			}
			return str.join("&");
		}
	}, {
		key: 'queryObject',
		value: function queryObject() {
			var search = location.search.substring(1);
			return this.queryStringToArray(search);
			// return search ? JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : {}
		}
	}, {
		key: 'queryStringToArray',
		value: function queryStringToArray(queryString) {
			var request = {};
			var keys = [];
			var pairs = queryString.substring(queryString.indexOf('?') + 1).split('&');
			for (var i = 0; i < pairs.length; i++) {
				var pair = pairs[i].split('=');
				var key = decodeURIComponent(pair[0]);
				var key = key.substring(0, key.indexOf('['));

				if (request[key]) request[key].push(decodeURIComponent(pair[1]));else request[key] = [decodeURIComponent(pair[1])];
			}
			return request;
		}
	}, {
		key: 'transformFiltersToArray',
		value: function transformFiltersToArray(filters) {
			var myArray = [];
			Object.keys(filters).forEach(function (key, index) {
				myArray.push({
					type: key,
					values: filters[key]
				});
			});
			return myArray;
		}
	}]);

	return Filters;
}(_react2.default.Component);

exports.default = Filters;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/directory/Filters.js
// module id = 514
// module chunks = 0